// LiquidErrorCheck([document.head,document.body],'Liquid error');

function LiquidErrorCheck(arr, string) {
  var checkingFor = (string).toLowerCase().toString(), hasError;
  arr.forEach(function (content, index, arr) {
    var check1 = content.textContent.toLowerCase().toString().indexOf(checkingFor) > 0,
      check2 = content.outerText.toLowerCase().toString().indexOf(checkingFor) > 0,
      check3 = content.outerHTML.toLowerCase().toString().indexOf(checkingFor) > 0,
      check4 = content.innerText.toLowerCase().toString().indexOf(checkingFor) > 0,
      check5 = content.innerHTML.toLowerCase().toString().indexOf(checkingFor) > 0;
    hasError = check1 || check2 || check3 || check4 || check5; 
      if (hasError) {
        arr.length = index + 1;
      }
  })
  if (hasError) {
    console.log('%c\n!!!!!!!!!!!!!!!!!!! \n\nLiquid error found! \n\n!!!!!!!!!!!!!!!!!!!\n ', 'color: red; font-size: 25px');
  } else {
    console.log('%c No liquid errors found. ', 'color: white; background: green; font-size: 16px');
  }
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true })
    
    this.input = this.querySelector('input');
    console.log(this.querySelectorAll('button'))
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    this.lockBody();
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    this.unlockBody();
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  lockBody() {
    waitForJavascript(function() {
      var lastTop = $(window).scrollTop();
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').addClass('locked').css({ top: -lastTop });
      if ( isIOS ) {
        var hght = window.innerHeight - 1;
        // console.log(hght)
        // console.log(hght+1)
        $('body').css({ height: hght});
      }
    })
  }
  unlockBody(el) {
    waitForJavascript(function() {
      var lastTop = Math.abs(parseInt($('body').css('top')));
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').css({ top:0}).removeClass('locked');
      window.scrollTo(0, lastTop);
      if ( isIOS ) {
        $('body')[0].style.removeProperty('height');
      }
    })
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    this.lockBody()
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    this.unlockBody()
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }

  lockBody() {
    var lastTop = $(window).scrollTop();
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    $('body').addClass('locked').css({ top: -lastTop });
    if ( isIOS ) {
      var hght = window.innerHeight - 1;
      // console.log(hght)
      // console.log(hght+1)
      $('body').css({ height: hght});
    }
  }
  unlockBody(el) {
    var lastTop = Math.abs(parseInt($('body').css('top')));
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    $('body').css({ top:0}).removeClass('locked');
    window.scrollTo(0, lastTop);
    if ( isIOS ) {
      $('body')[0].style.removeProperty('height');
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    this.lockBody()
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.unlockBody()
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }


  lockBody() {
    var lastTop = $(window).scrollTop();
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    $('body').addClass('locked').css({ top: -lastTop });
    if ( isIOS ) {
      var hght = window.innerHeight - 1;
      // console.log(hght)
      // console.log(hght+1)
      $('body').css({ height: hght});
    }
  }
  unlockBody(el) {
    var lastTop = Math.abs(parseInt($('body').css('top')));
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    $('body').css({ top:0}).removeClass('locked');
    window.scrollTo(0, lastTop);
    if ( isIOS ) {
      $('body')[0].style.removeProperty('height');
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if(!this.slider) return false;
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variantMetafields = JSON.parse(this.querySelector('#mainProductMetafieldsJson')?.textContent?? null);
    this.addEventListener('change', this.onVariantChange);
    this.createMonogramLabels();
  }
  connectedCallback() {
    console.log('VariantSelects connectedCallback called');
    this.updateAvailability(); // Call to update availability on page load
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.createMonogramLabels();
    
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.hideMonogram();
      this.showHideFinalSale(false);
    } else {
      this.updateMedia();
      this.updateURL();
      this.filterMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMonogramCustomizationVisibility();
    }
    this.updateAvailability(); // Call on variant change
  }

  filterMedia() {
    var currentVariantOpt1 = this.currentVariant.option1,
        currentVariantOpt2 = this.currentVariant.option2,
        currentVariantOpt3 = this.currentVariant.option3,
        thumbs = document.querySelectorAll('.thumbnail-list__item');
    for (const thumb of thumbs) {
      var colorAttr = thumb.getAttribute('thumbnail-color');
      thumb.classList.add('hide');
      if ( 
          (currentVariantOpt1 != '' && colorAttr.includes(currentVariantOpt1)) ||
          (currentVariantOpt2 != '' && colorAttr.includes(currentVariantOpt2)) ||
          (currentVariantOpt3 != '' && colorAttr.includes(currentVariantOpt3))
        ) {
        thumb.classList.remove('hide');
      }
    }
  }

  hideMonogram() {
    const monogramContainer = document.querySelector('.monogram-container');
    if(!monogramContainer) return;
    monogramContainer.style.display = 'none'
  }

  createMonogramLabels() {
    
    let monogramItem = '[data-embroidery-step="embroidery_style"] .jtbc-attribute-item[data-element-value],[data-embroidery-step="embroidery_color"] .jtbc-attribute-item[data-element-value]';
    watchForElement(monogramItem,function(el) {
      runCreate();
    })

    runCreate();

    function runCreate() {
      let monogramItems = document.querySelectorAll(monogramItem);
      monogramItems.forEach((item) => {
        let title = JSON.parse(item.dataset.tooltip).title;
        // item.setAttribute('data-label',title);
        item.classList.add('span-title');
        let spanElement = document.createElement("span");
        spanElement.textContent = title;
        item.appendChild(spanElement);
      });
    }
  }

  showHideFinalSale(show) {
    const saleEl = document.querySelector('.product__info-container .final-sale-text')
    if (saleEl) {
      saleEl.classList.toggle('show',show)
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateMonogramCustomizationVisibility() {

    const monogramContainer = document.querySelector('.monogram-container');
    if(!monogramContainer) return;
    monogramContainer.style.display = 'none'
    if(this.currentVariant.option1 != "Split King" && this.currentVariant.option1 != "Wash" && (this.currentVariant.inventory_policy == "deny" && this.currentVariant.inventory_quantity > 0) || this.currentVariant.inventory_policy == "continue"){
      monogramContainer.style.display = 'block'
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

    // Update Monogram Script accordingly
    const monogramModal = document.querySelector('[data-modal="monogram-modal"]');
    if(monogramModal) {
      //Remove old script
      document.querySelector('#monogram-script').remove();

      //Make new script with same id
      const newScript = document.createElement('script');
      newScript.id = "monogram-script"
      newScript.src = `https://silhouette.jtbcustom.com/js/loader/${this.currentVariant.id}.js`
      
      //Add new script
      document.querySelector('head').appendChild(newScript)
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  showHideBISForm(show,newHTML) {
    const form = document.querySelector('.out-of-stock-form')
    form.classList.toggle('hide',!show)
    form.querySelector('#p_id').value = newHTML.querySelector('#p_id').value
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (html.querySelector('.final-sale-text')?.classList.contains('show')) {
          this.showHideFinalSale(true);
        } else {
          this.showHideFinalSale(false)
        }

        const newForm = html.querySelector('.out-of-stock-form');
        this.showHideBISForm(!newForm.classList.contains('hide'),newForm);

        // const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinations = document.querySelectorAll(".product .price-item");

        for (const destination of destinations) {
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          if (source && destination) destination.innerHTML = source.innerHTML;

          // const price = document.getElementById(`price-${this.dataset.section}`);
          const price = destination;

          if (price) price.classList.remove('visibility-hidden');
        }

        const variant = this.variantMetafields.find(o => o.variant_id == this.currentVariant.id);

        if(variant?.allow_pre_order == "true") {
          this.toggleAddButton(false, 'Preorder');
          // Show the shipping date if the variant is available.
        } else {
          if(this.currentVariant.available) {
            this.toggleAddButton(false, '');
          } else {
            this.toggleAddButton(true, window.variantStrings.soldOut)
          }

        }

        // on var change message 
        const newDeliveryDate = html.querySelector('.delivery-message');
        const deliveryMessage = document.querySelector('.delivery-message');

        if (deliveryMessage){
          deliveryMessage.innerHTML = newDeliveryDate.innerHTML;
        }


        const updateSaleTag = html.querySelector('.product-form__input.is-color');
        const currentSaleTag = document.querySelector('.product-form__input.is-color');

        if (deliveryMessage){
          currentSaleTag.innerHTML = updateSaleTag.innerHTML;
        }
        this.updateAvailability();

      });
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const outOfStockForm = document.querySelector('.out-of-stock-form');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
      if (outOfStockForm != null) {
        outOfStockForm.classList.remove('hide');
        outOfStockForm.querySelector('[name="contact[product_id]"]').value = this.currentVariant.id;
      }
      }
    } else {
      addButton.removeAttribute('disabled');

      if(text) {
        addButtonText.textContent = text;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (outOfStockForm != null) {
        outOfStockForm.classList.add('hide')
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.variantMetafields = JSON.parse(this.querySelector('#mainProductMetafieldsJson')?.textContent?? null);
  }
  updateAvailability() {
    const variants = this.getVariantData();
    if (!variants) {
        console.error("Variant data not found for availability check.");
        return;
    }
  
    const fieldsets = Array.from(this.querySelectorAll('fieldset[data-option-pos]'));
    if (!fieldsets.length) return;
  
    // 1. Get current selections for all options based on checked radios
    const currentSelections = {};
    fieldsets.forEach(fieldset => {
      const optionPosition = parseInt(fieldset.dataset.optionPos, 10) - 1; // 0-indexed
      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput) {
        currentSelections[optionPosition] = checkedInput.value;
      } else {
        // Handle case where no option might be initially selected (shouldn't happen with radios usually)
        console.warn(`No option selected for fieldset position ${optionPosition + 1}`);
        // Optionally, find the first available default if needed, or handle error
        const firstInput = fieldset.querySelector('input[type="radio"]');
        if(firstInput) {
            // Attempt to select the first one as a fallback? Or determine default?
            // For now, just note it. The logic below relies on having selections.
            // If an option group *starts* with nothing checked, this needs more robust handling.
        }
      }
    });
    // console.log('Current Selections:', currentSelections); // Debugging
  
  
    // 2. Iterate through each option fieldset to apply/remove styles
    fieldsets.forEach(fieldset => {
      const optionIndexToCheck = parseInt(fieldset.dataset.optionPos, 10) - 1; // 0-indexed
  
      // 3. Iterate through each value (radio/label pair) within this fieldset
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        const valueToCheck = input.value;
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        if (!label) {
            console.warn(`Label not found for input ID: ${input.id}`);
            return; // Skip if label not found
        }
  
        // --- Logic only for COLOR SWATCHES ---
        
            // 4. Check if *any* available variant matches the *other* selections + this specific color value
            let isAvailable = variants.some(variant => {
              // Check if this variant is available for purchase
              if (!variant.available) return false;
  
              // Check if this variant's option matches the color value we're currently checking
              let matchesValueToCheck = variant.options[optionIndexToCheck] === valueToCheck;
              if (!matchesValueToCheck) return false;
  
              // Check if this variant matches ALL OTHER currently selected options
              let matchesOtherSelections = true;
              for (const index in currentSelections) {
                if (parseInt(index, 10) !== optionIndexToCheck) { // Don't check against the color option itself
                  if (variant.options[index] !== currentSelections[index]) {
                    matchesOtherSelections = false;
                    break;
                  }
                }
              }
              return matchesOtherSelections; // Returns true if available and all options match
            });
  
            // 5. Add or remove the 'variant--unavailable' class from the LABEL
            if (isAvailable) {
              label.classList.remove('variant--unavailable');
              // console.log(`Swatch ${valueToCheck} available with:`, currentSelections); // Debug
            } else {
              label.classList.add('variant--unavailable');
              // console.log(`Swatch ${valueToCheck} UNAVAILABLE with:`, currentSelections); // Debug
            }
        
      }); // End loop through inputs
    }); // End loop through fieldsets
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    // controls / connects to the Faux Selects used on mobile
    var targetElem = event.target;
    if (targetElem.classList.contains('faux-select')) {
      var fauxSelect = targetElem,
          fauxOption = fauxSelect.value,
          fauxID = fauxSelect.selectedOptions[0].getAttribute('data-id'),
          radio = document.getElementById(fauxID);
      radio.click();
    } else {
      var varRadio = targetElem,
          varRadioID = varRadio.id,
          select = varRadio.closest('.form__options').querySelector('select'),
          option = select.querySelector('[data-id="'+varRadioID+'"]');
      option.selected = true;
    }

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    // Sets the color name above the Swatches
    fieldsets.forEach(element => {
      var isColor = element.classList.contains('is-color');
      var isSize = element.classList.contains('select-option--size');

      // if (isColor) {
        var currentOption = Array.from(element.querySelectorAll('input')).find((radio) => radio.checked).value;
        element.querySelectorAll('.color-name')[0].innerText = currentOption;
        element.querySelectorAll('.color-name')[0].setAttribute('data-color',currentOption.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
      // }

      if (isSize) {
        var setTitle = document.querySelector('.current-size');
       // setTitle.innerText = currentOption;
      }
      this.updateMasterId();
      if (isColor && this.variantMetafields && this.currentVariant) {
        const options = Array.from(element.querySelectorAll('form__option'))
        const variants = this.getVariantData();
        const index = element.getAttribute('data-option-pos')
        const filterFunc = (v) => {
          const variant = this.variantMetafields.find(o => o.variant_id == v.id)
          if (!variant.show_on_sale) return
          switch (index) {
            case "1":
              return v.option2 == this.currentVariant.option2 && v.option3 == this.currentVariant.option3
            case "2":
              return v.option1 == this.currentVariant.option1 && v.option3 == this.currentVariant.option3
            case "3":
              return v.option1 == this.currentVariant.option1 && v.option2 == this.currentVariant.option2
            default:
              return false;
          }
        }

        const filtered = variants.filter(v=>filterFunc(v))
        
        options.forEach(opt=>{
          const color = opt.querySelector('input').getAttribute('value')
          const exists = filtered.some(fil => fil[`object${index}`] == color)
          opt.querySelector('.sale-tag').classList.toggle('visibility-hidden',!exists)
        })
      }

      element.addEventListener('change',(e)=>{
        //Check if Sticky ATC is active to prevent unnessary focus loss
        const stickyActive = e.target.closest('.sticky-add-to-cart')?.classList.contains('sticky');
        if(stickyActive){
          e.target.blur();
        }
      })
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);






function watchForElement(el, method) {
  chkDelay = '200'; // Amount of time between Checks
  var chkExist = setInterval(function() {
    chkClass = document.querySelectorAll(el)[0];
    if (typeof chkClass !== 'undefined') {
      // DO something
      clearInterval(chkExist);
      method(chkClass)
    }
  }, chkDelay);
}

// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })


function Modal(el) {
  el = el;
  act = 'active';
  actMod = 'modal-active';
  initMdl(el)

  function initMdl(el) {
    winWidth = $(window).width();
    thisEl = el;
    type = getDataName($(thisEl)).length ? getDataName($(thisEl)) : 'modal';
    thisMdl = getDataName($(thisEl)).length ? $('[data-modal="' + $(thisEl).data(type) + '"]') : $(thisEl);
    if (type == 'open' || type == 'modal') {
      if (!thisMdl.is('.' + act)) {
        showModal(thisMdl);
      } else {
        hideModal(thisMdl);
      }
    }
    if (type == 'close') {
      hideModal(thisMdl);
    }
  }

  function showModal(el) {
    var lastTop = $(window).scrollTop(),
      el = $(el),
      delay = 0;
    $('body').addClass(actMod).css({ top: -lastTop });
    if (el.is('[style*=display]')) {
      el[0].removeAttribute('style');
      delay = 100; // gives a moment for animation settings to take over
    }
    setTimeout(function() {
      el.addClass(act);
      el.find(':focusable').first().focus();
    }, delay)
  }

  function hideModal(el) {
    var lastTop = Math.abs(parseInt($('body').css('top'))),
      el = $(el);
    $('body').css({ top: 0 }).removeClass(actMod);
    window.scrollTo(0, lastTop);
    el.removeClass(act);
  }

  function getDataName(node) {
    var d = {},
      key = '',
      re_dataAttr = /^data\-(.+)$/;
    $.each(node.get(0).attributes, function(index, attr) {
      if (re_dataAttr.test(attr.nodeName)) {
        key = attr.nodeName.match(re_dataAttr)[1];
      }
    });
    return key;
  }
}


waitForJavascript(function() {


  jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector) {
      return $(el).is('a, button, :input, label, [tabindex]');
    }
  });


  // Accordian
  $('#tabs-select').on('change', function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      // window.location = url; // redirect
      $('a[href="' + url + '"]').trigger('click');
    }
    return false;
  });

  // sidebar links
  $('.accordion-section .sidebar-link').on('click  touch', function() {
    // body...
    $('.accordion-section .sidebar-link').removeClass('active');
    $(this).addClass('active');
  })
  // Accordian
  $(document).on('touch click', '.acc-btn', function() {
    var btn = '.acc-btn',
      $ths = $(this),
      animTime = 300,
      justClickedDelay = 500,
      justClicked = false,
      active = 'selected',
      cont = '.acc-content',
      par = '.acc-container',
      ttlTxt = 'h3',
      imgItm = '.img',
      $thsPar = $ths.closest(par),
      clckdIndx = $ths.closest('.site-footer').length == 0 ? $thsPar.find(btn).index($ths) : 0, //must not have '- 1' for section style, if page style stops working a new solution is needed
      $cont = $ths.next(cont),
      inrChld = $cont.children(),
      inrChldHght = inrChld.outerHeight(),
      $thsTtl = $thsPar.find(ttlTxt).eq(clckdIndx),
      $thsImg = $thsPar.find(imgItm).eq(clckdIndx),
      isOpen = $thsTtl.hasClass(active),
      winWidth = $(window).width(),
      clearItem = $('#shopify-section-header'),
      actTab = $(ttlTxt + '.' + active),
      actTabTop = !!actTab ? '' : actTab[0].getBoundingClientRect().top + window.scrollY;

      // console.log($ths)
      // console.log(clckdIndx)
    if (!!clearItem && !!actTab) {
      actTabTop = actTabTop + clearItem.outerHeight(true) + 15;
    }

    if (!justClicked) {
      justClicked = true;
      if (isOpen) {
        removeClasses();
        openClose();
        // console.log('close')
      } else {
        // console.log('open')
        removeClasses();
        addClasses();
        openClose(true);
        // mobScroll();
      }
      setTimeout(function() {
        justClicked = false;
      }, justClickedDelay);
    }

    function mobScroll() {
      if (winWidth < 750) {
        setTimeout(function() {
          // console.log(openTabDist)
          $([document.documentElement, document.body]).animate({
            scrollTop: openTabDist
          }, animTime);
        }, animTime * 2.5);
      }
    }

    function removeClasses() {
      $thsPar.find(btn + ' ' + ttlTxt).removeClass(active);
      $thsPar.find(btn + ' ' + imgItm).removeClass(active);
    }

    function addClasses() {
      $thsTtl.addClass(active);
      $thsImg.addClass(active);
    }

    function zeroHght() {
      $thsPar.find(cont).stop().animate({ height: 0 }, animTime);
    }

    function setHght() {
      $thsPar.find(cont).eq(clckdIndx).stop().animate({ height: inrChldHght }, animTime);
    }

    function openClose(dir) {
      if (dir == 'open' || dir == true) {
        zeroHght()
        setHght()
      } else {
        setHght()
        zeroHght()
      }
    }
  });



  // on load
  thisHash = window.location.hash;
  clearThis = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height() + 25;

  // removes hash from href
  // history.pushState(thisHash, '', window.location.pathname);
  if (thisHash.length > 0) {
    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $(thisHash).offset().top - clearThis
      }, 1000);
    }, 200)
  }
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#recover"]')
    .not('[href="#login"]')
    .not('[href="#0"]')
    // .not('.recomProdAd')
    .click(function(event) {

      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - clearThis
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });


  var actLogin = 'active';
  if (thisHash.length > 0 && thisHash == '#recover') {
    $('.' + actLogin).removeClass(actLogin);
    $(thisHash).addClass(actLogin);
  }
  $('[href="#recover"],[href="#login"]').click(function(e) {
    e.preventDefault()
    var tar = $(this).attr('href');
    $('.' + actLogin).removeClass(actLogin);
    $(tar).addClass(actLogin);
  })

  $('a')
    .not('#boldmetrics-ssc-activator')
    .not('.img-tab-link-2') // .not() ignores anchors with this class
    .not('[href*="tel:"]')
    .not('[href*="mailto:"]')
    .not('.product-single__thumbnail')
    .not('[href="#recover"]')
    .not('[href="#login"]')
    .not('[href="javascript:void(0);"]')
    .each(function() {
      var a = new RegExp('/' + window.location.host + '/');
      if (!a.test(this.href)) {
        $(this).click(function(event) {
          if (!$(this).is('#boldmetrics-ssc-activator')) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, '_blank');
          }
        });
      }
    });


  // show/hide back to top
  // backToTop()
  // $(document).scroll(function() {
  //   backToTop()
  // });
  // $(document).resize(function() {
  //   backToTop()
  // });

  // function backToTop() {
  //   var topBtn = $('.back-to-top'),
  //     act = 'show-top',
  //     fromTop = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop,
  //     minDist = window.innerHeight * 0.75;
  //   if (fromTop > minDist) {
  //     topBtn.addClass(act)
  //   } else {
  //     topBtn.removeClass(act)
  //   }
  // }


  $('.js-filters-toggle').click(function(e) {
    $('html').toggleClass('filters-is-open');
    e.preventDefault();
  });


  $(document).ready(function() {
    $('.modal-action').on('click touch', function(e) {
      e.preventDefault();
      Modal($(this));
      // console.log($(this))

      var vid = $(this).closest('.video-modal').find('iframe');
      if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
        var vidSrc = vid.attr('src');
        // console.log(vidSrc)
        vid.attr('src', vidSrc);
      }
    })


    $('.btn-modal').on('click touch', function() {

      var thsId = $(this).attr('href');

      Modal($(thsId));
      // console.log($(thsId))

      var vid = $(thsId).find('iframe');
      if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
        var vidSrc = vid.attr('src');
        // console.log(vidSrc)
        vid.attr('src', vidSrc);
      }
    })
  })

  videoRatio()

  function videoRatio() {
    var vid = $('.video-ratio:not(.for-modal) iframe, .video-ratio:not(.for-modal) video');

    initRatio();
    $(window).resize(function() {
      initRatio();
    })

    function initRatio() {
      var winWdth = $(window).width(),
        ratio = 0.56;

      if (vid.length) {
        vid.each(function() {
          var thsVid = $(this);

          if (typeof thsVid.data('video-ratio') !== 'undefined') {
            var ratio = thsVid.data('video-ratio');
          }
          var thsVidPar = thsVid.closest('div'),
            thsVidParHght = thsVidPar.outerHeight(true),
            cssHght = thsVidParHght,
            cssWdth = cssHght / ratio;

          if (cssWdth < winWdth) {
            var cssWdth = winWdth,
              cssHght = cssWdth * ratio;
          }

          thsVid.attr('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')

        })
      }
    }
  }


    // New Navigation 
  $(document).ready(function() {
    var mega, drp, prvFxdHdrHght, prevDistFromTop;
    var winWdth = $(window).width(),
      distFromTop = document.documentElement.scrollTop,
      prevdistFromTop = distFromTop,
      mobInit = 1200,
      isDesk = winWdth >= mobInit,
      justClicked = false,
      fxdHdr = 'header.header',
      fxdHdrHght = $(fxdHdr).height(),
      mnCntnt = '#MainContent',
      lnk = '.nav-item',
      inrLnk = '.dropdown-link',
      drpDwn = '.dropdown-list',
      nulLnk = 'a[href="#"]',
      megaMenu = '.mega-pane',
      megaDta = 'megamenu',
      drpActive = 'active',
      bdyCls = 'locked',
      inr = 'inner-',
      otrItmDta = 'nav-item',
      inrItmDta = inr + otrItmDta,
      otrDrpDta = 'dropdown',
      inrDrpDta = inr + otrDrpDta,
      mobNav = '.mobile-nav',
      drpDwnStl = '.use-dropdown',
      openCloseMobNav = '.menu-btn,.close-nav',
      mobNavOpen = 'mobile-nav-open',
      navOpen = 'mobile-nav--open',
      navClose = 'mobile-nav--close',
      mobNavBG = '.mobile-nav-background-close',
      moveAside = '.move-aside',
      mobDrpTggl = '.menu-toggle',
      mobBckTggl = '.reverse',
      lvlOne = 'level-one',
      lvlTwo = 'level-two';

    function clickPolice(justClicked) {
      // console.log('clickPolice')
      // justClicked = true;
      // setTimeout(function() { justClicked = false;
      //   console.log(justClicked) }, 700);
    }

    var vars = mobInit, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl, drpDwnStl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt;

    initNav(vars)
    setTimeout(function () {
      // body...
      initNav(vars)
    },1000)
    $(window).resize(function() {
      initNav(vars)
    })
    $(window).scroll(function() {
      initNav(vars)
      closeMega()
    })

    function initNav(vars) {
      var winWdth = $(window).width(),
        fxdHdrHght = $(fxdHdr).height(),
        isDesk = winWdth >= mobInit;

      // This is needed to prevent mobile menu from being buggy. 
      $(lnk+','+inrLnk+','+megaMenu+','+drpDwn+',' +mobDrpTggl+','+lnk+' '+nulLnk+','+inrLnk+' '+nulLnk+','+openCloseMobNav+','+mobNavBG).off();


      if (prvFxdHdrHght != fxdHdrHght) {
        // $(megaMenu).css({
        //   top: fxdHdrHght
        // });
        var prvFxdHdrHght = fxdHdrHght;
      }
      if (isDesk == true) {
        $(lnk + ',' + inrLnk).off().on('mouseover mouseleave focusin focusout', function(e) {
          if (!justClicked && isDesk) {
            clickPolice()

            if (e.type == 'mouseover' || e.type == 'focusin') {
              openLinks($(this))
            }
            if (e.type == 'mouseleave') {
              closeLinks($(this))
            }
            if (e.type == 'focusout') {
              fcsChkr($(this))
            }
          }
        })
        $(megaMenu + ',' + drpDwn).off().on('mouseleave focusout', function(e) {
          if (!justClicked && isDesk) {
            clickPolice()

            if (e.type == 'mouseleave' && $(this).is(megaMenu)) {
              closeMega($(this))
            }
            if (e.type == 'focusout' && $(this).is(megaMenu)) {
              fcsChkr($(this))
            }
            if (e.type == 'mouseleave' && $(this).is(drpDwn)) {
              closeLinks($(this))
            }
          }
        })
      } else {
        $(mobDrpTggl + ',' + lnk + ' ' + nulLnk + ',' + inrLnk + ' ' + nulLnk).off().on('touch click', function(e) {
          if (!justClicked && !isDesk) {
            clickPolice()


            // If arrow click
            if ($(this).is(mobDrpTggl)) {
              ths = $(this);
            }
            // if null link ('#' as href)
            if ($(this).is(nulLnk)) {
              e.preventDefault();
              ths = $(this).parent().children(mobDrpTggl);
            }
            openMobLnk(ths)


          }
        })
        $(openCloseMobNav + ',' + mobNavBG).off().on('touch click', function(e) {
          e.preventDefault();
          if (!justClicked && !isDesk) {
            clickPolice()

            toggleMobNav()
          }
        })
      }

    }

    function openLinks(el) {
      var $thsLnk = $(el),
        isAct = $thsLnk.is('.' + drpActive),
        otrData = $thsLnk.data(otrItmDta),
        inrData = $thsLnk.data(inrItmDta);
      if (!!otrData || !!inrData) {
        closeLinks($thsLnk)
      }
      if (!isAct) {
        $thsLnk.addClass(drpActive);
        // Activate Megamenu
        var mega = $('[data-' + megaDta + '="' + otrData + '"]');
        if (!!mega) {
          if ( typeof mega[0] !== 'undefined' && mega[0].querySelectorAll('.lazyload.defer').length > 0 ) {
            mega[0].querySelectorAll('.lazyload.defer').forEach(function (image, index) {
              image.classList.remove('defer');
            });
            LazyImages();
          }
          fxdHdrHght = $(fxdHdr).height();
          mega
            // .css({top: fxdHdrHght})
            .addClass(drpActive);
        }
      }
    }

    function closeLinks(el) {
      var $thsLnk = $(el),
        otrData = $thsLnk.data(otrItmDta),
        inrAct = $thsLnk.is('.' + drpActive),
        megaAct = $('[data-' + megaDta + '="' + otrData + '"]').is('.' + drpActive);
      if (!megaAct && !inrAct) {
        $(drpDwn + ',' + megaMenu + ',' + lnk + ',' + inrLnk).removeClass(drpActive);
      }
    }

    function closeMega(el) {
      $(drpDwn + ',' + megaMenu).removeClass(drpActive);
      $(lnk).removeClass(drpActive);
    }

    function toggleMobNav(e) {
      // Prevent any event bubbling
      if (e && e.preventDefault) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      console.log('Toggle mobile nav called');
      
      const header = document.querySelector(fxdHdr);
      const mobileNav = document.querySelector(mobNav);
      const mobileNavBG = document.querySelector(mobNavBG);
      
      if (!header || !mobileNav || !mobileNavBG) {
        console.warn('Required elements not found');
        return;
      }

      // Check if we're currently in a transition
      if (mobileNav.hasAttribute('data-transitioning')) {
        console.log('Navigation is currently transitioning');
        return;
      }

      const isAct = mobileNav.classList.contains(drpActive);
      console.log('Current nav state:', { isAct, classes: mobileNav.classList.toString() });

      // Set transitioning state
      mobileNav.setAttribute('data-transitioning', 'true');

      if (!isAct) {
        // Opening nav
        lockBody();
        const distFromTop = document.documentElement.scrollTop;
        
        // Force a browser reflow before adding classes
        void mobileNav.offsetWidth;
        
        // Add all active classes synchronously
        mobileNav.classList.add(drpActive);
        mobileNavBG.classList.add(drpActive);
        
        const menuBtn = document.querySelector(openCloseMobNav);
        if (menuBtn) {
          menuBtn.classList.add(navClose);
          menuBtn.classList.remove(navOpen);
        }
        
        header.classList.add(mobNavOpen);
        
        // Store the state
        mobileNav.setAttribute('data-nav-state', 'open');
        
        console.log('Nav opened:', { 
          navClasses: mobileNav.classList.toString(),
          headerClasses: header.classList.toString() 
        });
      } else {
        // Closing nav
        unlockBody();
        
        const menuBtn = document.querySelector(openCloseMobNav);
        if (menuBtn) {
          menuBtn.classList.remove(navClose);
          menuBtn.classList.add(navOpen);
        }
        
        // Remove classes synchronously
        mobileNav.classList.remove(drpActive);
        mobileNavBG.classList.remove(drpActive);
        
        // Reset all active states
        mobileNav.querySelectorAll('.'+drpActive).forEach(el => {
          el.classList.remove(drpActive);
        });
        
        const moveAsideEl = document.querySelector(moveAside);
        if (moveAsideEl) {
          moveAsideEl.classList.remove(lvlOne);
          moveAsideEl.classList.remove(lvlTwo);
        }
        
        header.classList.remove(mobNavOpen);
        
        // Store the state
        mobileNav.setAttribute('data-nav-state', 'closed');
        
        console.log('Nav closed:', { 
          navClasses: mobileNav.classList.toString(),
          headerClasses: header.classList.toString() 
        });
      }
      
      prevDistFromTop = distFromTop;

      // Remove transitioning state after a short delay
      setTimeout(() => {
        mobileNav.removeAttribute('data-transitioning');
      }, 100);
      
      return false;
    }

    // Add event listener with specific handling
    document.addEventListener('DOMContentLoaded', () => {
      const menuBtn = document.querySelector(openCloseMobNav);
      if (menuBtn) {
        // Remove any existing listeners
        const newBtn = menuBtn.cloneNode(true);
        menuBtn.parentNode.replaceChild(newBtn, menuBtn);
        
        // Add new click listener with debounce
        let lastClick = 0;
        newBtn.addEventListener('click', (e) => {
          const now = Date.now();
          if (now - lastClick < 200) {
            // Prevent rapid clicking
            return;
          }
          lastClick = now;
          
          e.preventDefault();
          e.stopPropagation();
          toggleMobNav(e);
          return false;
        }, { passive: false });
      }
      
      // Add click handler for background to close nav
      const navBG = document.querySelector(mobNavBG);
      if (navBG) {
        navBG.addEventListener('click', (e) => {
          const mobileNav = document.querySelector(mobNav);
          if (mobileNav && mobileNav.classList.contains(drpActive)) {
            toggleMobNav(e);
          }
        });
      }
    });

    function openMobLnk(el) {
      var $thsLnk = $(el),
        isDrpTggl = $thsLnk.is(mobDrpTggl),
        isBckTggl = $thsLnk.is(mobBckTggl),
        $thsPar = $thsLnk.parent(),
        isDropStyle = $thsLnk.closest(drpDwnStl).length > 0,
        isAct = $thsPar.is('.' + drpActive),
        moveLvlOne = $(moveAside).is('.' + lvlOne),
        moveLvlTwo = $(moveAside).is('.' + lvlTwo);
      // Move to Second Level
      if (!moveLvlOne && $thsPar.is(lnk) && !isDropStyle) {
        remActive($thsPar)
        addActive($thsPar)
        togLvl(moveAside, lvlOne)
      }
      // Move to Third level
      if (!moveLvlTwo && $thsPar.is(inrLnk) && !isDropStyle) {
        remActive($thsPar)
        addActive($thsPar)
        togLvl(moveAside, lvlTwo)
      }
      // Move back to Second level
      if (moveLvlTwo && moveLvlOne && isBckTggl && !isDropStyle) {
        togLvl(moveAside, lvlTwo)
        remActive($thsPar)
      }
      // Move back to First level
      else if (moveLvlOne && isBckTggl && !isDropStyle) {
        togLvl(moveAside, lvlOne)
        remActive($thsPar)
      }

      // Drop Style
      if (isDropStyle) {
        if (isAct) {
          closeHeights($thsPar)
        } else {
          // console.log(0)
          if ($thsPar.is(lnk)) {
            // console.log(1)
            $(lnk + ',' + inrLnk).each(function() {
              closeHeights($(this))
            })
          }
          if ($thsPar.is(inrLnk)) {
            // console.log(2)
            $(inrLnk).each(function() {
              closeHeights($(this))
            })
          }
          openHeight($thsPar)
        }
      }

      function closeHeights(el) {
        var el = el;
        //  $inrList = el.children(drpDwn,inrDrpDwn),
        //  opnHght = !!$inrList ? null : $inrList[0].scrollHeight;
        // if ( opnHght != null ) {
        //  console.log(1,el,opnHght)
        //  $inrList.css('max-height',opnHght)
        //  $inrList.css('max-height','0px')
        // //   .animate({
        // //     maxHeight: '0px'
        // //   },200)
        // //   // .css('max-height','0px')
        // }
        el.removeClass(drpActive)
      }

      function openHeight(el) {
        var el = el;
        //  $inrList = el.children(drpDwn,inrDrpDwn),
        //  opnHght = !!$inrList ? null : $inrList[0].scrollHeight;
        // if ( opnHght != null ) {
        //  console.log(2,el,opnHght)
        //  $inrList.css('max-height',opnHght)
        //  setTimeout(function () {
        //    $inrList.css('max-height','100%')
        //  },500)
        // }
        el.addClass(drpActive)
      }

      function remActive(el) {
        setTimeout(function() {
          $thsPar.parent().children().removeClass(drpActive)
        }, 200)
      }

      function addActive(el) {
        setTimeout(function() {
          $thsPar.addClass(drpActive);
        }, 200)
      }

      function togLvl(el, cls) {
        setTimeout(function() {
          if ($(el).is('.' + cls)) {
            $(el).removeClass(cls)
          } else {
            $(el).addClass(cls);
          }
        }, 200)
      }
    }
    
    function lockBody() {
      var lastTop = $(window).scrollTop();
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').addClass(bdyCls).css({ top: -lastTop });
      if ( isIOS ) {
        var hght = window.innerHeight - 1;
        // console.log(hght)
        // console.log(hght+1)
        $('body').css({ height: hght});
      }
    }
    function unlockBody(el) {
      var lastTop = Math.abs(parseInt($('body').css('top')));
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').css({ top:0}).removeClass(bdyCls);
      window.scrollTo(0, lastTop);
      if ( isIOS ) {
        $('body')[0].style.removeProperty('height');
      }
    }

    function fcsChkr(el) {
      var $thsLnk = $(el);
      checker = setTimeout(function() {
        if (!$thsLnk.find(':focus').length) {
          closeLinks($thsLnk);
        }
      }, 0);
      clearTimeout(checker)
    }
  });



  if($('body').hasClass('template--product')){
    var initTopPosition= $('.template--product .product__info-wrapper .product-form__buttons').offset().top;
    // console.log(initTopPosition);
    $(window).scroll(function(){
      // console.log($(window).scrollTop(),initTopPosition);
      if($(window).scrollTop() > initTopPosition)
        $('.template--product .product__info-wrapper .product-form__buttons').addClass("sticky");
      else
        $('.template--product .product__info-wrapper .product-form__buttons').removeClass("sticky");

    });
  }











  // var selects = $('variant-radios'), 
  //     selectSiblings = selects.parent().children(),
  //     selectPosition = selects.index() - 1;
  // $('.rc_label__onetime,.rc_label__autodeliver').on('click touch',function () {
  //   var button = $(this);
  //   if ( button.is('.rc_label__onetime') ) {
  //     move(selects,button,'after')
  //   } else {
  //     move(selects,selectSiblings.eq(selectPosition),'after')
  //   }
  // });




  // var parent        = '*:not(.quick-add-modal__content-info) .product__media',
  //     child         = 'img.zoom-image';
  // $(document).on('mousemove', parent, function() {
  //   var element     = {
  //     width: $(this).width(),
  //     height: $(this).height()
  //   };
  //   var mouse       = {
  //     x: event.pageX,
  //     y: event.pageY
  //   };
  //   var offset      = $(this).offset();
  //   var origin      = {
  //     x: (offset.left + (element.width / 2)),
  //     y: (offset.top + (element.height / 2))
  //   };
  //   var trans       = {
  //     left: (origin.x - mouse.x) / 2,
  //     down: (origin.y - mouse.y) / 2
  //   };
  //   var transform   = ("scale(2,2) translateX(" + trans.left + "px) translateY(" + trans.down + "px)");
  //   $(this).children(child).css("transform", transform);
  //   // console.log('Zoooooming')
  // });
  // $(document).on('mouseleave', parent, function() {
  //   $(this).children(child).css("transform", "none");
  //   // console.log('All Regular Sized')
  // });



  var parent = '*:not(.quick-add-modal__content-info) .product__media',
      child = 'img.zoom-image',
      zoomClass = 'zoomed',
      cursorZoomIn = 'zoom-in',
      cursorZoomOut = 'zoom-out',
      logs = false,
      childZoom = child + '.' + zoomClass;

  function zoomIn(el) {
    element = { width: el.width(), height: el.height() };
    scale = 2;
    ratio = scale * .35;
    mouse = { x: event.pageX, y: event.pageY };
    offset = el.offset();
    origin = { x: (offset.left + (element.width * ratio)), y: (offset.top + (element.height * ratio)) };
    trans = { left: (origin.x - mouse.x) * ratio, down: (origin.y - mouse.y) * ratio };
    transform = ("scale(" + scale + ',' + scale + ") translateX(" + trans.left + "px) translateY(" + trans.down + "px)");
  }
  $(document).on('click touch', parent, function() {
    var el = $(this);
    if (el.children(child).is('.' + zoomClass)) {
      el.css('cursor', cursorZoomIn).children(child).removeClass(zoomClass).css("transform", 'none').css('left','0').css('top','0');
      if (logs == true) { console.log('Zoom Off.') }
    } else {
      zoomIn(el);
      $(this).css('cursor', cursorZoomOut).children(child).addClass(zoomClass).css("transform", transform).css('left',-trans.left).css('top',-trans.down);
      if (logs == true) { console.log('Zoom On.') }
    }
  }).on('mousemove', parent, function() {
    var el = $(this);
    zoomIn(el);
    el.children(childZoom).css("transform", transform).css('left',-trans.left).css('top',-trans.down);
    if (logs == true) { console.log('Zoooooming') }
  }).on('mouseleave', parent, function() {
    var el = $(this);
    el.css('cursor', cursorZoomIn).children(childZoom).css("transform", 'none').css('left','0').css('top','0').removeClass(zoomClass);
    if (logs == true) { console.log('All Regular Sized') }
  });
  
});





// document.addEventListener('DOMContentLoaded', function () {
//   positionChange(
//     '.product .swym-wishlist-button-bar', 
//     '.product .product__media-gallery', 
//     '.product .rating-wishlist'
//   )
//   watchForElement('.product .affirm-as-low-as',function(el) {
//     positionChange(
//       '.product .affirm-as-low-as', 
//       '.product .sticky-button', 
//       '.product .quickbuy-move',
//       'prepend',
//       'append'
//     )
//   }); 
// });

function positionChange(elemToMove, mobPar, dskPar, mobPlcmt, dskPlcmt, changeAt) {
  var elemToMove    = document.querySelector(elemToMove),
      mobPar        = document.querySelector(mobPar);
  
  if (!elemToMove && !mobPar) return false;

  var dskPar        = elemToMove.closest(dskPar),
      changeAt      = typeof changeAt == 'undefined' ? 750 : changeAt,
      mobPlcmt      = typeof mobPlcmt == 'undefined' ? 'append' : mobPlcmt,
      dskPlcmt      = typeof dskPlcmt == 'undefined' ? 'append' : dskPlcmt,
      mobChk        = 'mob',
      deskChk       = 'desk',
      moved         = deskChk;

  initPos();
  window.addEventListener("resize", initPos);

  function initPos() {
    var wdth        = window.innerWidth,
        above       = wdth >= changeAt && moved != deskChk,
        below       = wdth < changeAt && moved != mobChk;
    if ( above ) {
      move(elemToMove, dskPar, dskPlcmt);
      moved         = deskChk;
    } 
    if ( below ) {
      move(elemToMove, mobPar, mobPlcmt);
      moved         = mobChk;
    } 
  }
}

function move(elem, moveElemHere, placement) {
  if (placement == 'before') {
    moveElemHere.parentNode.insertBefore(elem, moveElemHere);
  } else if (placement == 'after') {
    if (moveElemHere.nextSibling) {
      moveElemHere.parentNode.insertBefore(elem, moveElemHere.nextSibling);
    } else {
      moveElemHere.parentNode.appendChild(elem);
    }
  } else if (placement == 'prepend') {
    moveElemHere.insertBefore(elem, moveElemHere.firstChild);
  } else {
    moveElemHere.appendChild(elem);
  }
}


window.addEventListener("scroll", function() {
  var stickyAddToCart   = document.querySelector('.template--product .product .sticky-add-to-cart');
  if ( stickyAddToCart != null ) {
    var wideEnough        = window.innerWidth >= 1200,
        wideEnough        = true,
        stickyOffset      = 100,
        stickyHeight      = stickyAddToCart.offsetHeight,
        stickyClass       = 'sticky',
        shouldStick       = window.scrollY > (stickyAddToCart.offsetTop + stickyHeight + stickyOffset),
        isSticky          = stickyAddToCart.classList.contains(stickyClass);
    if ( shouldStick && !isSticky && wideEnough ) {
      stickyAddToCart.style.minHeight = stickyHeight+'px';
      stickyAddToCart.classList.add(stickyClass);
    }
    if ( !shouldStick && isSticky || !wideEnough ) {
      stickyAddToCart.style.removeProperty('min-height');
      stickyAddToCart.classList.remove(stickyClass);
    }
  }
});


function updateProductCardImage(e) {
  const button = e.currentTarget;
  var image = button.getAttribute("data-varimg");
  var color = button.getAttribute("data-color");
  var prodId = button.getAttribute("data-prodId");
  var varId = button.getAttribute("data-varid");
  var parentSwatch = button.closest('.card--media');
  var parent = button.closest('.card-wrapper');
  parentSwatch.querySelectorAll('.swatch-element').forEach(function (el, index) {
    el.classList.remove('active');
  });
  button.classList.add('active');
  var imgElem =  parentSwatch.querySelectorAll('.image-content__image')[0];
  imgElem.src = image;
  imgElem.srcset = image;
  if ( parent.querySelector('#color-'+prodId) && parent.querySelector('#size-'+prodId) ) {
    console.log(parent.querySelector('#color-'+prodId))
    var size = parent.querySelector('#size-'+prodId).value
    parent.querySelector('#color-'+prodId).value = color;
    /* setting variant */
    setVariantCard(parent,prodId,color,size);
  }
  const overlayLink = parent.querySelector('.overlay-link');
  if (overlayLink){
    const link = overlayLink.getAttribute('href').split('?')[0];
    parent.querySelector('.overlay-link').setAttribute('href',link+"?variant="+varId);
  }
    
}

document.querySelectorAll(".card__content .size").forEach( select => {
  select.addEventListener('change', function() {
    var parent = select.closest('.card-wrapper');
    var prodId = select.getAttribute("data-prodId");
    var color = parent.querySelector('#color-'+prodId).value
    var size = this.value;
    setVariantCard(parent,prodId,color,size);
  });
});


function setVariantCard(parent,prodId,color,size){
  
  var prodJson = JSON.parse(parent.querySelector('#setJson-' + prodId).innerHTML);
  var newArray = prodJson.filter(function (el) {
        return el.option1 == size && el.option2 == color;
      }
  );

  if(newArray.length > 0){
    var prodForm = parent.querySelector('#setForm-'+prodId);
     parent.querySelector('.card-price').textContent  = '$'+newArray[0].price/100;
    prodForm.getElementsByClassName('product-select')[0].value = newArray[0].id;
  }
}


var addAll = document.getElementById('addAll');
if ( addAll ) {
  addAll.addEventListener('click',function (){
    var items=[];
    document.querySelectorAll(".product-form form").forEach( form => {
      items.push({
        quantity: 1,
        id: form.getElementsByClassName('product-select')[0].value

      })
    });
    jQuery.post('/cart/add.js', {
      items
    }).then(function(){
     window.location = '/cart'
    });
  });
}



var registerFormsubmitted = false;
if ( document.querySelector("#create_customer #submit-button") != null ) {
  document.querySelector("#create_customer #submit-button").onclick = function (e){
    if(registerFormsubmitted == false){
      e.preventDefault();
      console.log(123);
      var sms_marketing = false;

      if(document.querySelector('#accepts_sms_marketing').checked){
        sms_marketing =  true;
      }

      let data = {
        "api_key": "pk_600d842669e8f2a1035e49f4615546326e",
        "profiles": [
          {
            "phone_number": "+12345678900",
            "sms_consent": sms_marketing
          }
        ]
      }
      let post = JSON.stringify(data)

      const url = "https://jsonplaceholder.typicode.com/posts"
      let xhr = new XMLHttpRequest()

      xhr.open('POST', url, true)
      xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
      xhr.setRequestHeader('Cache-Control', 'no-cache; charset=UTF-8')
      xhr.send(post);

      xhr.onload = function () {
        if(xhr.status === 201) {
          console.log("Post successfully created!")
          registerFormsubmitted = true;
        }
      }
    }
  };
}




var yotpoRatingText = '.rating-replace .sr-only';
var wrapWords = ' star rating';
watchForElement(yotpoRatingText,function(el) {
  $(yotpoRatingText+":contains('"+wrapWords+"')").html(function(_, html) {
    var replace = new RegExp(wrapWords,"g");
    return html.replace(replace, '<span class="visually-hidden">'+wrapWords+'</span>');
  });
})
/*on enter key search form submit*/
// Get the input field and form element
const searchField = document.getElementById('header-search--3');


// Add an event listener to the input field
searchField?.addEventListener('keyup', function (event) {
  // Check if the key pressed is Enter (key code 13)
  console.log(event);
  if (event.key === 'Enter') {
    // Prevent the default form submission
    event.preventDefault();
  const searchForm =  event.target.closest('form');
    // Submit the form
    searchForm.submit();
  }
});

class HeartButton extends HTMLElement {
  constructor() {
    super();
    this.initializeElements();
    this.setupListeners();
  }

  async getProjectsList() {
    this.loaderId.style.display = 'block';

    // Reset div content
    this.outputDiv.textContent = '';

    const customerId = this.customerId.value;
    try {
      const response = await fetch(
        `${wishAppURL}/ext-api/project/getProjectsList?customerId=${customerId}`
      );
      if (!response.ok) throw Error('Network response was not ok');

      const finalData = await response.json();

      if (finalData.items?.length > 0) {
        this.addToList.classList.replace('d-none', 'd-block');
        this.createNewListButton1a.classList.replace('d-block', 'd-none');

        finalData.items.forEach((item) => {
          let categoryHtml = '';
          if (item.categories) {
            item.categories.forEach((category, index) => {
              const isChecked = index === 0 ? 'checked' : '';
              categoryHtml += `
            <li>
              <label class="radio-container testing">
                <input
                  data-category-title="${category.title}"
                  type="radio"
                  name="catItem"
                  value="${category.id}"
                  ${isChecked}>
                <span class="checkmark"></span>
                ${category.title == 'null' ? 'General' : category.title}
              </label>
            </li>
          `;
            });
          }
          const listItemFinal = `<li>
          <label class="radio-container">
            <input
              type="radio"
              checked="checked"
              id="input-field-${item.id}"
              name="listItem"
              value="${item.id}">
            <span class="checkmark"></span>
             ${item.title}
          <p class="items-count">(${item.items} items)</p>
          <ul class="inner-rooms-list chk">
            <li>
              <label class="radio-container">
                <input
                  type="radio"
                  name="catItem"
                  value="null"
                  class = "default-checked"
                   >
                <span class="checkmark"></span>
                None
              </label>
            </li>
              ${categoryHtml}
          </ul>
          
          </label>
          <div class="divider"></div>
            </li>`;
          this.outputDiv.innerHTML += listItemFinal;
        });

        if (this.defaultChecked) this.defaultChecked.checked = true;
        this.loaderId.style.display = 'none';
      } else {
        this.addToList.classList.replace('d-block', 'd-none');
        this.createNewListButton1a.classList.replace('d-none', 'd-block');
      }
    } catch (error) {
      this.loaderId.style.display = 'none';
      console.error('Fetch error:', error);
    } finally {
      this.modal.style.display = 'block';
      this.backdrop.style.display = 'block';
      this.createListModal.style.display = 'none';
    }
  }

  initializeElements() {
    this.backdrop = document.querySelector('#backdrop');
    this.modal = document.querySelector('#exampleModalCenter1');
    this.createListModal = document.querySelector('#exampleModalCenter');
    this.closeButton = document.querySelector('.close');
    this.closeButton1 = document.querySelector('.close1');
    this.createButtonListItem = document.querySelector('#createButtonListItem');
    this.openFavModel = document.querySelector('#openFavModel');
    this.loaderId = document.querySelector('#loaderId');
    this.outputDiv = document.querySelector('#parentUL');
    this.customerId = document.querySelector('#customerId');
    this.addToList = document.querySelector('#add-to-list');
    this.createNewListButton1a = document.querySelector(
      '#createNewListButton1a'
    );
    this.defaultChecked = document.querySelector('.default-checked');
  }

  setupListeners() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.getProjectsList();
      document
        .querySelector('modal-container')
        .setTarget(
          this.closest('.product-container') ?? this.closest('.product')
        );
      this.modal.style.display = 'block';
      this.createListModal.style.display = 'none';
    });

    this.createButtonListItem.addEventListener('click', (event) => {
      event.preventDefault();
      this.getProjectsList();
      this.modal.style.display = 'block';
      this.createListModal.style.display = 'none';
    });
  }
}

try {
  document.addEventListener('DOMContentLoaded', initializeListeners);
} catch (error) {
  console.log(error)
} 

if (!customElements.get('heart-button'))
  customElements.define('heart-button', HeartButton);

class ModalContainer extends HTMLElement {
  constructor() {
    super();
    this.initializeElements();
    this.setupListeners();
  }

  initializeElements() {
    this.addToList = this.querySelector('#add-to-list');
    this.showNewListInput = this.querySelector('#showNewListInput');
    this.newListName = this.querySelector('#newListName');
    this.categoryList = this.querySelector('#categoryList');
    this.hideNewListInput = this.querySelector('#hideNewListInput');
    this.addCategoryInput = this.querySelector('#addCategoryInput');
    this.loader = this.querySelector('#loaderId');
    this.scrollToTop = this.querySelector('#scrollToTop');
    this.saveCategoryButton = this.querySelector('#saveCategoryButton');
    this.exampleModalCenter1 = this.querySelector('#exampleModalCenter1');
    this.backdrop = this.querySelector('#backdrop');

    this.modalFooterButton = this.querySelector('.modal-footer button');
    this.saveCategoryButton = this.querySelector('#saveCategoryButton');

    this.newListNameChild = this.querySelector('#newListNameChild');
    this.customerId = this.querySelector('#customerId');
    this.parentUL = this.querySelector('#parentUL');

    // Will be set by heart icon clicking on button
    this.productEl = undefined;
  }

  setTarget(el) {
    this.productEl = el;
  }

  async _createNewProjectAddCategories(id, title) {
    const allCategories = [];

    const categoryEls = Array.from(
      document.getElementsByClassName('list-category-input')
    );

    for (const categoryEl of categoryEls) {
      const val = categoryEl.value.trim();
      if (val) allCategories.push(val);
    }

    if (allCategories.length) {
      const data = {
        title: title,
        projectId: id,
        categories: allCategories,
      };

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        redirect: 'follow',
      };

      const response = await fetch(
        `${wishAppURL}/ext-api/category/create`,
        options
      );

      if (!response.ok) return;

      const responseObj = await response.json();
      this.loader.style.display = 'none';
      showToast('Successfully Added');
      this.addToList.classList.remove('d-none');
      this.showNewListInput.classList.remove('d-none');
      this.newListName.classList.add('d-none');
      this.hideNewListInput.classList.add('d-none');
      const categoryArray = Array.from(
        document.getElementsByClassName('remove-all-li')
      );
      categoryArray.forEach((el) => el.remove());

      _getProjectsListUpdated(responseObj[0].project_id, responseObj[0].id);
    } else {
      _getProjectsListUpdated(id, null);
    }
  }

  async _getProjectsListUpdated(id, categroryIdApi) {
    this.loader.style.display = 'block';
    this.parentUL.textContent = '';
    const customerId = this.customerId.value;
    try {
      const response = await fetch(
        `${wishAppURL}/ext-api/project/getProjectsList?customerId=${customerId}`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const finalData = await response.json();
      const categories = finalData.categories;

      if (finalData.items?.length > 0) {
        this.addToList.classList.replace('d-none', 'd-block');
        this.createNewListButton1a.classList.replace('d-block', 'd-none');

        finalData.items.forEach((item) => {
          let categoryHtml = '';
          if (item.categories) {
            item.categories.forEach((category, index) => {
              const isChecked = index === 0 ? 'checked' : '';
              categoryHtml += `
              <li>
                <label class="radio-container testing">
                  <input
                    data-category-title="${category.title}"
                    type="radio"
                    name="catItem"
                    value="${category.id}"
                    ${isChecked}>
                  <span class="checkmark"></span>
                  ${category.title == 'null' ? 'General' : category.title}
                </label>
              </li>
            `;
            });
          }
          const listItemFinal = `<li>
            <label class="radio-container">
              <input
                type="radio"
                checked="checked"
                id="input-field-${item.id}"
                name="listItem"
                value="${item.id}">
              <span class="checkmark"></span>
               ${item.title}
            <p class="items-count">(${item.items} items)</p>
            <ul class="inner-rooms-list chk">
              <li>
                <label class="radio-container">
                  <input
                    type="radio"
                    name="catItem"
                    value="null"
                    class = "default-checked"
                     >
                  <span class="checkmark"></span>
                  None
                </label>
              </li>
                ${categoryHtml}
            </ul>
            
            </label>
            <div class="divider"></div>
              </li>`;
          this.parentUL.innerHTML += listItemFinal;
        });

        if (this.defaultChecked) this.defaultChecked.checked = true;
        this.loader.style.display = 'none';
      } else {
        this.addToList.classList.replace('d-block', 'd-none');
        this.createNewListButton1a.classList.replace('d-none', 'd-block');
      }

      const c = this.querySelector('.default-checked');
      if (c) c.checked = true;

      this.loader.classList.add('d-none');
      this.querySelector(`#input-field-${id}`).checked = true;
      if (categroryIdApi != null) {
        this.querySelector(
          `'data-category-parent-' + ${categroryIdApi}`
        ).checked = true;
      }
      this.hideNewListInput.click();
    } catch (error) {
      this.loader.style.display = 'block';
      console.log(error);
    } finally {
      this.exampleModalCenter1.style.display = 'block';
      this.backdrop.style.display = 'block';
    }
  }

  async createNewList(event) {
    event.preventDefault();
    this.loader.classList.add('d-block');

    const apiUrl = `${wishAppURL}/ext-api/project/create`;

    if (!this.newListNameChild.value?.trim()) {
      showToast('List Name is required');
      this.loader.classList.replace('d-block', 'd-none');
      return;
    }

    const data = {
      title: this.newListNameChild.value,
      customerId: this.customerId.value,
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(apiUrl, options);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const responseData = await response.json();
  }

  setupListeners() {
    this.modalFooterButton.addEventListener(
      'click',
      this.createNewList.bind(this)
    );
    this.saveCategoryButton.addEventListener(
      'click',
      this.createNewList.bind(this)
    );

    this.showNewListInput.addEventListener('click', (event) => {
      event.preventDefault();
      this.addToList.classList.add('d-none');
      this.showNewListInput.classList.add('d-none');
      this.newListName.classList.remove('d-none');
      this.hideNewListInput.classList.remove('d-none');
      this.scrollToTop.scrollTo({
        top: this.scrollToTop.scrollHeight,
        behavior: 'smooth',
      });
    });

    this.hideNewListInput.addEventListener('click', (event) => {
      event.preventDefault();
      this.addToList.classList.remove('d-none');
      this.showNewListInput.classList.remove('d-none');
      this.newListName.classList.add('d-none');
      this.hideNewListInput.classList.add('d-none');
    });

    this.addCategoryInput.addEventListener('click', (event) => {
      event.preventDefault();
      const inputEl = document.createElement('input');
      inputEl.type = 'text'; // You can change this to other input types like 'number', 'email', etc.
      inputEl.placeholder = 'Ex : Bedroom';
      inputEl.classList.add(
        'custom-input',
        'mt-1',
        'list-category-input',
        'remove-all-li'
      );

      this.categoryList.appendChild(inputEl);
      this.saveCategoryButton.classList.replace('d-none', 'd-block');
    });

    this.addToList.addEventListener('click', async (event) => {
      event.preventDefault();
      const apiUrl = `${wishAppURL}/ext-api/item/create`;
      const listItem = this.querySelector('input[name="listItem"]:checked');
      const parentUL = listItem.closest('ul');
      const catId =
        parentUL.querySelector('input[name="catItem"]:checked').value == 'null'
          ? null
          : parentUL.querySelector('input[name="catItem"]:checked').value;

      const data = {
        productHandle: this.productEl.querySelector(
          'input[name="productHandle"]'
        ).value,
        productId: this.productEl.querySelector('input[name="productId"]')
          .value,
        variantId: this.productEl.querySelector('input[name="id"]').value,
        project_id: listItem.value,
        imgSrc: this.productEl.querySelector('input[name="imageSource"]').value,
        categoryId: catId,
      };

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert the data object to JSON string
      };

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw Error('Network response was not ok');

      this.loader.style.display = 'none';
      this.newListName.classList.add('d-none');
      this.exampleModalCenter1.style.display = 'none';
      this.backdrop.style.display = 'none';
      showToast('Successfully Added!');
    });
  }
}

if (!customElements.get('modal-container'))
  customElements.define('modal-container', ModalContainer);


var yotpoTabWidget = '.yotpo-layout-header-wrapper';
watchForElement(yotpoTabWidget,function(el) {
  move(document.querySelector('.yotpo-header-container'), document.querySelector('.yotpo-main-widget-tabs'),'before');
})



// place at bottom of main js file
var themeJSisLoaded = true;
